import { type ReactNode } from "react";

interface SkeletonProps {
  className?: string;
  rounded?: string;
}

export function Skeleton({ className = "", rounded = "" }: SkeletonProps) {
  return (
    <div
      className={`bg-surface animate-pulse ${rounded || "rounded-lg"} ${className}`}
    />
  );
}

export function SkeletonText({ lines = 1, className = "" }: { lines?: number; className?: string }) {
  return (
    <div className={`flex flex-col gap-2 ${className}`}>
      {Array.from({ length: lines }).map((_, i) => (
        <Skeleton
          key={i}
          className={`h-4 ${i === lines - 1 && lines > 1 ? "w-3/4" : "w-full"}`}
        />
      ))}
    </div>
  );
}

export function SkeletonCard({ children }: { children?: ReactNode }) {
  return (
    <div className="bg-surface border border-hairline rounded-2xl p-5">
      {children ?? (
        <div className="flex flex-col gap-3">
          <Skeleton className="h-5 w-1/2" />
          <SkeletonText lines={2} />
        </div>
      )}
    </div>
  );
}
